module.exports = __webpack_public_path__ + "img/E8.4951766d.svg";